<template>
    <div class="saved-product-container">
        <div class="item-image">
            <spinner :show="isImageLoading" />
            <img :class="{ image: true, 'image--loading': isImageLoading }" :src="productColorImage.url" :key="productColorImage.id" v-images-loaded="imageLoaded" />
        </div>
        <div class="item-info">
            <div class="item-brand">
                <span v-if="currentProduct.product_brand_title">{{ currentProduct.product_brand_title }}</span>
                <a class="cross" @click="$emit('unsave', currentProduct)"></a>
            </div>
            <div class="item-name" :class="{ noBrand: !currentProduct.product_brand_title }">{{
                currentProduct.product_title
            }}</div>
            <div class="item-price">{{ currentProduct.product_price | currency }}</div>
            <color-size-selector
                ref="colorSizeSelector"
                :colors="currentProduct.product_colors"
                :sizes="sortedSizes"
                :selectedColorId="selectedColorId"
                :selectedSizeId="selectedSizeId"
                :isPristine="currentProduct.isPristine"
                :showValidation="true"
                @color-changed="colorChanged"
                @size-changed="sizeChanged" />

            <template v-if="isVariantOOS || isProductOOS">
                <swap-item-button
                    classes="add-to-cart-btn oos swap"
                    text="SWAP"
                    icon="white"
                    @click="$emit('requested-swap', currentProduct)"
                />
                <button class="add-to-cart-btn oos" :disabled="true">
                    OUT OF STOCK
                </button>
            </template>
            <template v-else>
                <button class="add-to-cart-btn" :class="{'add-to-cart-btn--disabled': !selectedColorId || !selectedSizeId}" @click="addProductToCart">Move to cart</button>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ColorSizeSelector from '../products/color-size-selector.vue';
    import SwapItemButton from '../products/swap-item-button.vue';
    import Spinner from '../common/spinner.vue';
    import imagesLoaded from 'vue-images-loaded';

    import Mixins from '../../mixins/mixins';
    import ProductMixins from '../../mixins/product-mixins.js';
    import $ from 'webpack-zepto';

    export default {
        props: {
            product: Object
        },
        data() {
            return {
                selectedColorId: this.product.product_option_value_id_color,
                selectedSizeId: this.product.product_option_value_id_size,
                isVariantOOS: false,
                isImageLoading: true,
            }
        },
        mixins: [Mixins, ProductMixins],
        components: {
            ColorSizeSelector,
            SwapItemButton,
            Spinner,
        },
        directives: {
            imagesLoaded,
        },
        computed: {
            sortedSizes() {
                return this.sortSizes(this.getColorSizes(this.currentProduct));
            },
            productColorImage() {
                const color = this.currentProduct.product_colors.find(color => color.product_option_value_id == this.selectedColorId) || {};
                return {
                    url: color.image_url || this.currentProduct.product_image_url,
                    id: color.image_id || this.currentProduct.product_image_id,
                };
            },
            currentProduct() {
                return {
                    ...this.product,
                    product_option_value_id_color: this.selectedColorId,
                    product_option_value_id_size: this.selectedSizeId
                };   
            },
            isProductOOS() {
                return this.currentProduct.product_colors.every(color => color.available_sizes.lenght === 0) && this.currentProduct.product_sizes.every(size => size.in_stock == 0)
            },
        },
        methods: {
            addProductToCart() {
                if (this.$refs.colorSizeSelector?.isValid) {
                    let product = this.currentProduct;

                    product.product_option_value_id_color = this.selectedColorId;
                    product.product_option_value_id_size = this.selectedSizeId;

                    this.$emit('data-loading', true);

                    if (window.FirebasePlugin) {
                        window.FirebasePlugin.logEvent("add_to_cart", { content_id: product.product_id });
                    }
                    this.$store
                        .dispatch({
                            type: "cart/insertProductsToCart",
                            products: [
                                {
                                    ...product,
                                    selected: true,
                                },
                            ],
                        })
                        .then(() => {
                            this.$router.push({path: "/cart"});
                        })
                        .catch(error => {
                            console.log('error:', error);
                            window.FirebasePlugin.logEvent("add_to_cart_error", {content_id: product.product_id});
                            this.$store.dispatch('errors/put', error.message || 'Invalid product or option combination.');
                        })
                        .finally(() => {
                            this.$emit('data-loading', false);
                        });
                } else {
                    this.updatePristineStatus('color', this.product);
                    this.updatePristineStatus('size', this.product);
                }
            },
            colorChanged(event) {
                this.selectedColorId = event.target.value;
            },
            sizeChanged(event) {
                this.selectedSizeId = event.target.value;
            },
            imageLoaded() {
                this.isImageLoading = false;
            }
        },
        mounted() {
            if(typeof this.$refs.colorSizeSelector !== 'undefined') {
                this.isVariantOOS = this.$refs.colorSizeSelector?.isSizeOOS;
                this.$watch(() => this.$refs.colorSizeSelector?.isSizeOOS, (isOOS) => { this.isVariantOOS = isOOS; });
            }
        },
        watch: {
            productColorImage(value, prevValue) {
                if(prevValue.id !== this.productColorImage.id) this.isImageLoading = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .image {
        transition: opacity 0.3s ease-in-out;
    }
    .image--loading {
        opacity: 0;
    }
</style>